<template>
  <div class="text-left">
    <RejectCommentLayout :comment-text="reject_comment" />
    <v-card>
      <v-form class="pa-6" ref="form">

        <!-- Button to open the SearchScopusForm modal -->
        <v-row justify="end">
          <v-btn color="primary" @click="$refs.searchScopusForm.openDialog()" append-icon="mdi-search">
            <v-icon left>mdi-auto-fix</v-icon>
            {{  $t("form.search_scopus") }}
          </v-btn>
        </v-row>

        <!-- Include the SearchScopusForm component -->
        <SearchScopusForm ref="searchScopusForm" @use-data="handleScopusData" />

        <NewPublication
          :publication="publication"
          :mod-op_id="modOp_id"
          :disabled-form="disabledForm"
          @change-files="emitChangeFiles"
          @save-form="saveform_trigger = !saveform_trigger"
        />
        <v-row>
          <v-col cols="12">
            <h3 class="mt-15 mb-0">
              {{ $t("title.communicationData") }}
            </h3>
          </v-col>
        </v-row>
        <div class="required-label">
          <h5 class="mb-2">
            {{ $t("form.communication.congress_edition") }}
          </h5>
          <v-chip x-small outlined color="primary">
            {{ $t("form.mandatory") }}
          </v-chip>
        </div>
        <v-row>
          <v-col cols="12" lg="6" class="py-0">
            <v-combobox
              v-model="congressEditionSelected"
              :items="congressEditions"
              item-text="name"
              :label="$t('form.communication.congress_edition')"
              return-object
              :clearable="!disabledForm"
              outlined
              :readonly="disabledForm"
              :rules="rules.fieldRequired"
            />
          </v-col>
          <v-col cols="12" lg="6" class="py-0">
            <v-checkbox
              v-model="publication.communication.presented_on_main"
              class="big"
              :readonly="disabledForm"
              :label="$t('form.communication.mainConferenceDetail')"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6" class="py-0">
            <div class="required-label">
              <h5 class="mb-2">
                {{ $t("form.communication.date") }}
              </h5>
              <v-chip x-small outlined color="primary">
                {{ $t("form.mandatory") }}
              </v-chip>
            </div>
            <v-row>
              <v-col class="py-0">
                <v-menu
                  v-model="menu_communication_date"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                  :disabled="disabledForm"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      outlined
                      v-model="publication.communication.date"
                      :label="$t('form.communication.date')"
                      prepend-inner-icon="event"
                      readonly
                      v-on="on"
                      :rules="rules.fieldRequired"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="publication.communication.date"
                    @input="menu_communication_date = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="6" class="py-0">
            <div class="required-label">
              <h5 class="mb-2">
                {{ $t("form.communication.type") }}
              </h5>
              <v-chip x-small outlined color="primary">
                {{ $t("form.mandatory") }}
              </v-chip>
            </div>
            <v-row>
              <v-col class="py-0">
                <v-select
                  outlined
                  v-model="publication.communication.type"
                  :label="$t('form.communication.type')"
                  :rules="rules.fieldRequired"
                  :items="communicationTypes"
                  :readonly="disabledForm"
                  item-value="value"
                  item-text="text"
                />
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6" class="py-0">
            <h5>
              {{ $t("form.communication.lecture_notes") }}
            </h5>
            <v-row>
              <v-col class="py-0">
                <v-text-field
                  v-model="publication.communication.lecture_notes"
                  :readonly="disabledForm"
                  :label="$t('form.communication.lecture_notes')"
                  :rules="rules.char_max_70"
                  :counter="70"
                  outlined
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="6" class="py-0">
            <h5>
              {{ $t("form.communication.prizes") }}
            </h5>
                <v-row>
                  <v-col class="py-0">
                    <v-text-field
                      v-model="publication.communication.prizes"
                      :readonly="disabledForm"
                      :label="$t('form.communication.prizes')"
                      :rules="rules.char_max_150"
                      :counter="150"
                      outlined
                    ></v-text-field>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <div class="required-label">
          <h5 class="mb-2">
            {{ $t("form.communication.feder_acknowledgements") }}
          </h5>
          <v-chip x-small outlined color="primary">
            {{ $t("form.mandatory") }}
          </v-chip>
        </div>
        <v-row>
          <v-col class="py-0">
            <v-checkbox
              class="big"
              v-model="publication.communication.feder_acknowledgements"
              :label="$t('form.federAcknowledgementsDetail')"
              :readonly="disabledForm"
              indeterminate
              :rules="rules.checkboxRequired"
            />
          </v-col>
        </v-row>

        <v-divider />
        <UserFormActions
          form_name_text="new communication"
          :form_name="form_name"
          :refForm="$refs.form"
          :object_type="object_type"
          :data="processData"
          :state="state"
          :saveform_trigger="saveform_trigger"
          @change-state="changeState"
          :paginated-form="true"
          class="text-center mt-6"
        />
      </v-form>
    </v-card>
  </div>
</template>

<script>
import axios from "axios";
import RejectCommentLayout from "../../layouts/RejectCommentLayout";
import UserFormActions from "../../action_buttons/UserFormActions";
import changeState from "../../../mixins/changeState";
import validationRules from "../../../mixins/validationRules";
import NewPublication from "./NewPublication";
import publication_model from "../../../mixins/model_utils/publication_model";
import publication_data from "../../../mixins/publication_data";
import SearchScopusForm from "@/components/reusables/SearchScopusForm";

export default {
  mixins: [changeState, validationRules, publication_data, publication_model],
  components: {
    NewPublication,
    RejectCommentLayout,
    UserFormActions,
    SearchScopusForm
  },

  data: () => ({
    form_name: "newCommunicationForm",
    menu: false,
    saveform_trigger: false,
    state: "",
    reject_comment: "",
    object_id: null,
    object_type: "publication",
    menu_communication_date: false,
    congressEditionSelected: null,
    modOp_id: null
  }),

  created() {
    this.getCommunicationTypes();
    this.getCongressEditions();
    if (this.updatePublication || this.updatePublicationForm) {
      this.getPublication();
    } else {
      if (this.$store.getters.user !== null) {
        this.loadDefaultAuthor();
      }
    }
  },

  computed: {
    updatePublicationForm() {
      return this.$route.params.id > -1 && !this.updatePublication;
    },
    updatePublication() {
      return this.$route.params.id > -1 && this.$route.meta.update;
    },
    disabledForm() {
      let states = ["VD", "PA", "PV", "PC"];
      return states.includes(this.state);
    },
    processData() {
      let congressEdition = "";
      if (this.congressEditionSelected !== null) {
        if (typeof this.congressEditionSelected == "string") {
          congressEdition = {
            id: null,
            name: this.congressEditionSelected
          };
        } else if (this.congressEditionSelected.id != null) {
          congressEdition = this.congressEditionSelected.id;
        } else {
          congressEdition = this.congressEditionSelected;
        }
      } else {
        congressEdition = null;
      }
      let data = {
        title: this.publication.title,
        object_type: this.object_type,
        form_name: this.form_name,
        object_id: this.object_id,
        data: {
          user: {
            publication: {
              title: this.publication.title,
              abstract: this.publication.abstract,
              acknowledgements: this.publication.acknowledgements,
              keywords: this.publication.keywords,
              doi: this.publication.doi,
              isbn: this.publication.isbn,
              authors_text: this.publication.authors_text,
              authorsrel: this.publication.authorsrel,
              num_authors: this.publication.num_authors,
              research_areas: this.publication.research_areas.filter(area =>
                Number.isInteger(area)
              ),
              links: this.publication.links,
              is_external: this.publication.is_external,
              hidden: this.publication.hidden,
              featured: this.publication.featured,
              language: this.publication.language,
              minerva_sync_option: this.publication.minerva_sync_option,
              regional: this.publication.regional,
              national: this.publication.national,
              international: this.publication.international,
              files: this.files,
              communication: {
                congress_edition: congressEdition,
                type: this.publication.communication.type,
                date: this.publication.communication.date,
                lecture_notes: this.publication.communication.lecture_notes,
                prizes: this.publication.communication.prizes,
                presented_on_main: this.publication.communication
                  .presented_on_main
              }
            }
          }
        }
      };
      return data;
    }
  },

  methods: {
    loadCongressEditionSelected(item) {
      if (item != undefined) {
        if (typeof item == "number") {
          this.congressEditionSelected = this.congressEditions.filter(
            congressEdition => congressEdition.id === item
          )[0];
        } else {
          this.congressEditionSelected = item;
        }
      }
    },
    getPublication() {
      let path =
        this.$store.state.endpoint +
        "/user/moderatedOperations/publication/" +
        this.$route.params.id;
      axios
        .get(path)
        .then(response => {
          this.modOp_id = response.data.id;
          this.publication = response.data.data.user.publication;
          this.normalizePublicationDefaults(this.publication);
          this.state = response.data.state;
          this.reject_comment = response.data.reject_comment;
          this.object_id = response.data.object_id;
          this.loadCongressEditionSelected(
            this.publication.communication.congress_edition
          );
        })
        .catch(error => {
          console.log(error);
        });
    },
    handleScopusData(data) {
      this.publication.abstract = data.abstract;
      this.publication.keywords = data.keywords;
      this.publication.authors_text = data.authors_text;
      this.publication.num_authors = data.num_authors;
      this.publication.doi = data.doi;
      this.publication.communication.date = data.publication_date;
      this.publication.communication.congress_edition = { id: null, name: data.conference };
      this.loadCongressEditionSelected({ id: null, name: data.conference });
      this.publication.links.publisher = data.url;
      this.publication.title = data.title;
    },
  }
};
</script>

<style scoped>
.required-label {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
}

.required-label .v-chip {
  margin-left: 8px;
}
</style>
